// extracted by css-extract-rspack-plugin
export default {"budgetStatusHint":"budget__status-hint--uYlPsgzcIOs3IuPe","row":"row--WSkW9SKMtgcujdFW","budgetAmount":"budget-amount--R4HJNiuDD9AX_KFd"};